<template>

    <div class="">
        <div class="shadow-lg rounded-lg flex flex-col border-t-4 border-blue-dark">
            <div class="">
                <div ref="column" class="p-4"></div>
                <div class="p-4 border-b border-t">
                    <div class="p-2 mt-8">
                        <time-slider :times="times" v-on:update="updateTime"></time-slider>
                    </div>
                    <div class="opacity-50 flex flex-row justify-between">
                        <div class="">
                            <button class="btn-secondary"
                                    v-on:click="rank = !rank"
                            >
                                <span v-show="!rank"><i class="fa fa-square-o fa-fw"></i></span>
                                <span v-show="rank"><i class="fa fa-check-square-o fa-fw"></i></span>
                                <span class="pl-1">rank items</span>
                            </button>
                            <button class="btn-secondary" v-on:click="hideEmpty = !hideEmpty">
                                <span v-show="hideEmpty"><i class="fa fa-square-o fa-fw"></i></span>
                                <span v-show="!hideEmpty"><i class="fa fa-check-square-o fa-fw"></i></span>
                                <span class="pl-1">include missing items</span>
                            </button>
                            <button class="btn-secondary" v-on:click="fixY = !fixY">
                                <span v-show="!fixY"><i class="fa fa-square-o fa-fw"></i></span>
                                <span v-show="fixY"><i class="fa fa-check-square-o fa-fw"></i></span>
                                <span class="pl-1">fix y-axis</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="p-4">
                    <a class="btn inline-block" @click="exportChart('image/svg+xml')">
                        <i class="fa fa-download"></i> SVG
                    </a>
                    <a class="btn inline-block" @click="exportChart('image/png')">
                        <i class="fa fa-download"></i> PNG
                    </a>
                    <a class="btn inline-block" href="#/export">
                        <i class="fa fa-download"></i> Export Data
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                chart: null,
                active: null,

                hideEmpty: false,
                fixY: false,
                rank: false,
            };
        },

        watch: {
            'rank': function () {
                this.barData();
            },
            'hideEmpty': function () {
                this.barData();
            },
            'fixY': function () {
                this.redraw();
            },
            'type': function () {
                this.barData();
            },
            'dimensionData': function () {
                this.redraw();
            },
            'activeDim': {
                handler: function () {
                    this.barData();
                },
                deep: true,
            },
        },

        mounted: function () {
            this.barData();
        },

        computed: {
            activeDim: function () {
                return this.$store.state.dimensions;
            },
            type: function () {
                return this.$store.state.typeMotion;
            },
            dimensionData: function () {
                return this.$store.getters.dimensionData;
            },
            variwideData: function () {
                let data = this.$store.getters.variwideData;

                if (this.rank) {
                    return _.sortBy(data, 1).reverse();
                }

                return data;
            },
            // TODO bullshit!
            time: function () {
                if (this.active) {
                    return this.active;
                }
                if (this.times.length > 0) {
                    return this.times[0];
                }
                return null;
            },
            times: function () {
                return this.$store.getters.times;
            },
            yAxis: function () {
                if (this.$store.state.typeMotion === 'scatter' || this.$store.state.typeMotion === 'variwide') {
                    return {
                        title: {
                            text: this.$store.state.dimensions.y.value,
                        },
                        labels: {
                            format: '{value}'
                        },
                    }
                }

                if (!this.fixY) {
                    return {};
                }

                return {
                    min: this.$store.getters.min,
                    max: this.$store.getters.max,
                };
            },
            xAxis() {
                if (this.$store.state.typeMotion === 'scatter') {

                    return {
                        min: undefined,
                        gridLineWidth: 1,
                        title: {
                            text: this.$store.state.dimensions.x.value,
                        },
                        labels: {
                            format: '{value}'
                        },
                        type: 'linear',
                    };
                }

                return {
                    categories: this.categories,
                    type: 'category',
                    title: {
                        text: null
                    },
                    opposite: this.opposite,
                    labels: {
                        step: 1,
                        rotation: this.rotation,
                        /*style: {
                            fontSize: '13px',
                            fontFamily: 'Verdana, sans-serif'
                        }*/
                    },
                    //min: min,
                    tickmarkPlacement: 'on',
                    //type: 'linear',
                    //tickInterval: 1,
                    //minRange: 1
                };
            },
            title: function () {
                return 'Ranking ' + this.time;
            },
            rotation: function () {
                if (this.$store.state.typeMotion === 'column' || this.$store.state.typeMotion === 'variwide') {
                    return -45;
                }
                return 0;
            },
            opposite: function () {
                return this.$store.state.typeMotion === 'bar';
            },
            chartData: function () {
                if (this.$store.state.typeMotion === 'scatter') {
                    return this.dimensionData;
                }

                if (this.$store.state.typeMotion === 'variwide') {
                    return this.variwideData;
                }

                return this.ranking.map(function (item) {
                    return {
                        name: item.name,
                        y: item.value,
                        color: item.color,
                    };
                });
            },

            categories: function () {
                if (this.$store.state.typeMotion === 'variwide') {
                    return this.variwideData.map(function (item) {
                        return item[0];
                    });
                }
                return this.chartData.map(function (item) {
                    return item.name;
                });
            },

            ranking: function () {
                const time = this.time;
                let ranking = [];

                this.$store.getters.compute.forEach(function (series) {
                    const result = _.find(series.data, {'time': time});

                    let value = null;

                    if (result !== undefined && result.value !== null) {
                        value = result.value;
                    }

                    ranking.push({name: series.name, value: value, color: series.color});
                });

                if (this.hideEmpty) {
                    ranking = ranking.filter(function (item) {
                        return item.value !== null;
                    });
                }

                if (this.rank) {
                    return _.sortBy(ranking, 'value').reverse();
                }

                return ranking;
            },
            tooltip() {
                if (this.$store.state.typeMotion === 'variwide') {
                    // TODO this is so ugly.
                    return {
                        headerFormat: '{point.key}<br>',
                        pointFormat: this.activeDim.x.value + ': <b>{point.y:.2f}</b><br>' + this.activeDim.y.value + ': <b>{point.z:.2f}</b>',
                    }
                }

                if (this.$store.state.typeMotion === 'scatter') {
                    return {
                        headerFormat: '{point.key}<br>',
                        pointFormat: this.activeDim.x.value + ': <b>{point.x:.2f}</b><br>' + this.activeDim.y.value + ': <b>{point.y:.2f}</b>',
                    }
                }
                return {
                    pointFormat: '{series.name}: <b>{point.y:.2f}</b>'
                }
            },
            series() {
                let series = [{
                    name: 'Values',
                    colorByPoint: true,
                    data: this.chartData,
                }];

                // TODO ... build a flag for this crap!
                if (this.$store.state.typeMotion === 'scatter' && false) {
                    series.push({
                        type: 'line',
                        name: 'Regression Line',
                        data: [[0, 0], [this.$store.getters.max, this.$store.getters.max]],
                        marker: {
                            enabled: false
                        },
                        states: {
                            hover: {
                                lineWidth: 0
                            }
                        },
                        enableMouseTracking: false
                    });
                }

                return series;
            },

        },

        methods: {
            updateTime: function (time) {
                this.active = time;
                this.$store.commit('setTime', time);
                this.redraw();
            },
            redraw: function () {
                if (this.fixY) {
                    this.chart.yAxis[0].setExtremes(this.$store.getters.min, this.$store.getters.max, false);
                } else {
                    this.chart.yAxis[0].setExtremes(null, null, false);
                }
                this.chart.series[0].setData(this.chartData, false);

                if (this.$store.state.typeMotion !== 'scatter') {
                    this.chart.xAxis[0].setCategories(this.categories, false);
                }

                this.chart.setSubtitle({text: this.title}, false);
                this.chart.redraw();
            },
            barData() {
                const text = this.$store.state.rawData.headline;
                const json = {
                    chart: {
                        zoomType: this.$store.state.typeMotion === 'variwide' ? null : 'x',
                        renderTo: this.$refs.column,
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: this.$store.state.typeMotion,
                    },
                    title: {
                        text: text,
                    },
                    subtitle: {
                        text: this.title,
                    },
                    tooltip: this.tooltip,
                    plotOptions: {
                        /*series: {
                            dataLabels: {
                                enabled: true,
                                format: function () { console.log(this.point);return this.x + ': ' + this.y },
                                inside: true,
                            },
                        },*/
                        pie: {
                            size: "75%",
                        },
                        scatter: {
                            allowPointSelect: true,
                        },
                        /*pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                                style: {
                                    color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                }
                            }
                        }*/
                    },
                    series: this.series,
                    xAxis: this.xAxis,
                    yAxis: this.yAxis,
                    credits: {
                        enabled: true,
                        href: 'https://www.allthatstats.com/',
                        text: 'Source: ' + this.$store.getters.sources,
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                enabled: false,
                            }
                        }
                    },
                };

                this.chart = null;
                this.chart = new Highcharts.Chart(json);
            },
            exportChart: function (type) {
                this.chart.exportChart({type: type});
            },
        }
    }
</script>
